import * as React from "react";
import { Building2, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
export default function JoinTheRevolution() {
  const companyDetails = [{
    label: "Entity Name",
    value: "BioPower SRL"
  }, {
    label: "Registration",
    value: "CU-77291-BIO"
  }, {
    label: "Sector",
    value: "35110 - Renewable Energy Production"
  }, {
    label: "Headquarters",
    value: "Calle 23, Vedado, La Habana, Cuba"
  }];
  return <section data-section-id="241909" id="join-the-revolution" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="bg-accent/30 border border-primary/10 py-16 md:py-24 px-8 md:px-12 rounded-2xl shadow-lg backdrop-blur-sm">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
            
            {}
            <div className="lg:col-span-5 flex flex-col justify-center space-y-8">
              <div>
                <div className="inline-flex items-center gap-2 bg-secondary/10 px-3 py-1 rounded-lg mb-6 border border-secondary/20">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689054/img/cuba_flag_badge.png" alt="Cuba" className="w-5 h-3 object-cover rounded-sm" />
                  <span className="text-xs font-bold tracking-widest uppercase text-secondary">Mejorando el futuro de cuba</span>
                </div>
                <h2 className="font-default text-4xl md:text-5xl font-bold tracking-tight text-foreground mb-4">Recicla tu aceite usado&nbsp;</h2>
                <p className="text-muted-foreground leading-relaxed text-lg">Contactanos para agendar la recogida de tu aceite usado. Protege el medioambiente y ayúdanos a crear una Cuba mas limpia para todos!</p>
              </div>

              <div className="space-y-5">
                <Link to="mailto:contact@biopower-srl.cu" className="group flex items-center gap-4 text-foreground hover:text-primary transition-colors duration-300 w-fit">
                  <div className="bg-card border border-border shadow-sm p-2.5 group-hover:border-primary/50 transition-colors rounded-lg">
                    <Mail className="size-5 text-primary" strokeWidth={1.5} />
                  </div>
                  <span className="font-default font-semibold tracking-wide">biopowercuba@gmail.com</span>
                </Link>
                
                <Link to="tel:+5378300000" className="group flex items-center gap-4 text-foreground hover:text-primary transition-colors duration-300 w-fit">
                  <div className="bg-card border border-border shadow-sm p-2.5 group-hover:border-primary/50 transition-colors rounded-lg">
                    <Phone className="size-5 text-secondary" strokeWidth={1.5} />
                  </div>
                  <span className="font-default font-semibold tracking-wide">+53 53 31 9829</span>
                </Link>

                <div className="flex items-start gap-4 text-foreground pt-2">
                  <div className="bg-card border border-border shadow-sm p-2.5 mt-1 rounded-lg hover:border-primary/50 transition-colors">
                    <MapPin className="size-5 text-chart-3" strokeWidth={1.5} />
                  </div>
                  <span className="font-default font-semibold tracking-wide leading-relaxed max-w-[200px]">Calle 23 Edf. 311 #1<br />Vedado, La Habana, Cuba</span>
                </div>
              </div>
            </div>

            {}
            <div className="lg:col-span-7 lg:pl-8 flex items-center">
              <div className="w-full bg-card border border-border shadow-xl p-1 rounded-2xl">
                <div className="bg-accent/5 p-6 md:p-8 rounded-xl">
                  <div className="flex items-center gap-3 mb-6 pb-4 border-b border-border">
                    <Building2 className="size-5 text-primary" strokeWidth={1.5} />
                    <h3 className="font-default text-xl font-bold tracking-wide text-foreground">Registro Empresarial</h3>
                  </div>
                  
                  <Table>
                    <TableBody>
                      {companyDetails.map((detail, index) => <TableRow key={detail.label} data-index={index} className="border-border/50 hover:bg-primary/5 transition-colors">
                          <TableCell className="py-4 font-default font-bold text-muted-foreground w-1/3 align-top">
                            {detail.label}
                          </TableCell>
                          <TableCell className="py-4 text-foreground font-mono text-right sm:text-left">
                            {detail.value}
                          </TableCell>
                        </TableRow>)}
                    </TableBody>
                  </Table>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>;
}